export default {
  title: 'Bliv en del af {{name}}!',
  default_program_name: 'Belønningsklub',
  benefits: {
    earn_points: 'Optjen point med hver ordre',
    get_deals: 'Få eksklusive rabatter',
    redeem_points: 'Indløs point til gratis mad',
  },
  terms: 'Ved at tilmelde dig modtager du e-mail- og sms-tilbud fra vores&nbsp;',
  buttons: {
    log_in: 'Log ind',
    sign_up: 'Tilmeld dig',
  },
  labels: {
    already_have_account: 'Har du allerede en konto?',
  },
  signup_note:
    'Ved at tilmelde dig modtager du e-mail- og sms-tilbud fra vores <0>restaurant</0> og <1>FoodAmigos</1>, vores teknologipartner. Du accepterer vores <2>platformvilkår</2> og <3>privatlivspolitik</3>.',
};
